// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunnerOptionalParameter,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { getAccounts, GetAccountsApiParameter } from "@insite/client-framework/Services/AccountService";
import { AccountCollectionModel } from "@insite/client-framework/Types/ApiModels";

// XNG-Changes: add AccountCollectionModel type to OnSuccess Callback
type HandlerType = ApiHandlerDiscreteParameter<
    GetAccountsApiParameter & HasOnSuccess<AccountCollectionModel>,
    GetAccountsApiParameter,
    AccountCollectionModel
>;

export const DispatchBeginLoadAccounts: HandlerType = props => {
    const { dispatch, parameter } = props;
    dispatch({
        type: "Data/Accounts/BeginLoadAccounts",
        parameter,
    });
};

export const PopulateApiParameter: HandlerType = props => {
    const newParameter = {
        ...props.parameter,
    };
    delete newParameter.onSuccess;
    props.apiParameter = newParameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getAccounts(props.apiParameter);
    } catch (error) {
        if ("status" in error && error.status === 403) {
            return false;
        }
        throw error;
    }
};

export const DispatchCompleteAccounts: HandlerType = props => {
    const { dispatch, parameter, apiResult } = props;
    dispatch({
        type: "Data/Accounts/CompleteLoadAccounts",
        parameter,
        collection: apiResult,
    });
};
// XNG-Changes: pass the apiResult to onSuccess Callback
export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.(props.apiResult);
};

export const chain = [
    DispatchBeginLoadAccounts,
    PopulateApiParameter,
    RequestDataFromApi,
    DispatchCompleteAccounts,
    ExecuteOnSuccessCallback,
];

const loadAccounts = createHandlerChainRunnerOptionalParameter(chain, {}, "LoadAccounts");
export default loadAccounts;
